<template>
  <div>
    <ModalBackground/>
    <div class="modal-container" @click.self="closeModalAction">
      <div class="inner">
        <div class="close-button-container" @click="closeModalAction">
          <CloseButton/>
        </div>
        <FormHelper class="form-container" @callback="callback" :formSettings="formSettings"/>
      </div>
    </div>
  </div>
</template>

<script>
import ModalBackground from '@/components/common/ModalBackground';
import FormHelper from '@/components/common/FormHelper';
import CloseButton from '@/components/user/CloseButton';

export default {
  components: {
    ModalBackground,
    FormHelper,
    CloseButton
  },
  data () {
    return {
      formSettings: { //フォームの設定を記載
        store: 'user',
        dispatch: 'resetPassword',
        header: 'パスワードをリセットします',
        forms: {
          email: {
            label: '登録メールアドレス',
            type: 'text',
            value: null,
            require: true,
            placeholder: this.$placeholderEmail,
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          }
        },
        useSessionId: false,
        submit: {
          label: 'リセット',
          color: 'b'
        },
        info: [ // フォーム下部の補足説明
          'パスワードリセットの案内メールをお送りします',
          '手順につきましては、お送りするメールをご確認ください'
        ],
        reasonCode: {
          EMAIL_NOT_FOUND: '登録さてれいないメールアドレスです'
        },
      }
    };
  },
  created: function () {
    // Form storeの初期化
    this.$store.dispatch('formValues/reset').then();
  },
  methods: {
    closeModalAction: function () {
      console.log('closeDialog');

      this.$emit('callback', 'pw_reset_close', null);

    },
    callback: function (dispatcher, value) {
      console.log('callback', dispatcher, value);

      if(dispatcher === 'FormHelperNotice'){
        // 何もしない
        // サーバー側でエラーメール処理
      }

      this.$emit('callback', 'pw_reset_finish', null);

    }
  }
};

</script>
